class AccordionSlider {
    constructor() {
        this.slides = document.querySelectorAll('.accordion-slide');
        this.init();
    }

    init() {
        if (this.slides.length === 0) return;

        // Optional: Auto-expand first slide on load
        if (window.innerWidth > 768) {
            setTimeout(() => {
                if (this.slides[0]) {
                    this.slides[0].classList.add('active');
                }
            }, 800);
        }

        // Add click handler for mobile
        this.slides.forEach(slide => {
            slide.addEventListener('click', () => {
                if (window.innerWidth <= 768) {
                    this.handleMobileClick(slide);
                }
            });
        });

        // Reset active state on mouse leave container
        const container = document.querySelector('.accordion-slider-wrapper');
        if (container) {
            container.addEventListener('mouseleave', () => {
                this.slides.forEach(s => s.classList.remove('active'));
            });
        }
    }

    handleMobileClick(clickedSlide) {
        // Toggle active class on mobile
        const wasActive = clickedSlide.classList.contains('active');
        
        this.slides.forEach(slide => {
            slide.classList.remove('active');
        });

        if (!wasActive) {
            clickedSlide.classList.add('active');
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new AccordionSlider();
    });
} else {
    new AccordionSlider();
}

// Re-initialize when Shopify section is reloaded (theme editor)
document.addEventListener('shopify:section:load', () => {
    new AccordionSlider();
});

